import request from "./request";

/**
 * Represents a location (ubicacion/visibilidad)
 */
interface Ubicacion {
  tipo: string;
  id: string;
  nombre: string;
}

/**
 * Represents module permissions
 * Each object has a module name as key and an array of permissions as value
 */
type ModuloPermisos = Record<string, string[]>;

/**
 * User access information returned from identity-management service
 */
export interface UserAccess {
  id: string;
  username: string;
  correo_electronico: string;
  fecha_creacion: string;
  colaborador_id: string;
  estatus: string;
  nombre: string;
  modulos: string[];
  permisos: ModuloPermisos[];
  rol: string;
  ubicacion: Ubicacion;
  categoria: string;
  visibilidad: Ubicacion;
}

/**
 * Fetches user access information by email
 *
 * @param email - The user's email address
 * @returns Promise with user access data and notifications
 *
 * @example
 * ```ts
 * const { data, notifications } = await getAccess('user@example.com');
 * if (data) {
 *   console.log('User ID:', data.id);
 *   console.log('Colaborador ID:', data.colaborador_id);
 *   console.log('Módulos:', data.modulos);
 *   console.log('Rol:', data.rol);
 * }
 * ```
 */
export default function getAccess(email: string) {
  return request<UserAccess>(
    `${import.meta.env.VITE_URL_BASE}/identity-management/${email}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
}
